import React, { useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import { Button } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";

import { SearchInput } from "components";

import { NavLink } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";


import {
  showSuccessSnackbar,
  showErrorSnackbar,
} from "store/actions/snackbarMessage";
import { updateUserkeyword } from "store/actions/account";
import { useConfirm } from "material-ui-confirm";
import { deleteDisplayClient } from "apis/devicesAPIs";
import { useMutation, QueryClient } from "@tanstack/react-query";

import { updateSelectedUserIds } from "store/actions/account";

const useStyles = makeStyles((theme) => ({
  root: {},
  row: {
    height: "42px",
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(1),
  },
  spacer: {
    flexGrow: 1,
  },
  importButton: {
    marginRight: theme.spacing(1),
  },
  exportButton: {
    marginRight: theme.spacing(1),
  },
  searchInput: {
    marginRight: theme.spacing(1),
  },
}));

const DisplayClientListToolbar = (props) => {
  const { className, ...rest } = props;
  const confirm = useConfirm();
  const [buttonLoading, setButtonLoading] = useState(false);
  
  const classes = useStyles();
  const dispatch = useDispatch();
  
  const selectedUserIds = useSelector((state) => state.account.selectedUserIds);
 
  const showSuccessMessage = (msg) => dispatch(showSuccessSnackbar(msg));
  const showErrorMessage = (msg) => dispatch(showErrorSnackbar(msg));
  const updateFilter = (key) => dispatch(updateUserkeyword(key));
  const updateUserIds = (ids) => dispatch(updateSelectedUserIds(ids));

  const queryClient = new QueryClient();
 
  // delete mutation
  const deleteMutation = useMutation({
    mutationFn: deleteDisplayClient,
    onSuccess: (data) => {
      showSuccessMessage("Display Client deleted successfully!");
      setButtonLoading(false);
      queryClient.invalidateQueries("displayClientList");
      updateUserIds([]);
      // reload url using window.location.reload()
      window.location.reload();
    },
    onError: (error) => {
      showErrorMessage("Something went wrong!");
      setButtonLoading(false);
    },
  });

  const deleteItem = () => {
    // console.log("selectedUserIds", selectedUserIds);
    if (!selectedUserIds || selectedUserIds.length === 0) {
      showErrorMessage("Please select a client!");
      return;
    }

    confirm({ description: "You are about to delete this client!" })
      .then(() => {
        setButtonLoading(true);
        deleteMutation.mutate(selectedUserIds[0]);
        
      })
      .catch(() => {
        /* ... */
      });
  };

  const filterUsers = (e) => {
    updateFilter(e.target.value);
  }; 



  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <div className={classes.row}>
        <span className={classes.spacer} />

        <IconButton
          aria-label="delete"
          onClick={deleteItem}
          disabled={buttonLoading}
        >
          <DeleteIcon />
        </IconButton>

     
        <NavLink to={"/displayClient"}>
          <Button color="primary" variant="contained">
            Add Display Client
          </Button>
        </NavLink>
      </div>
      <div className={classes.row}>
        <SearchInput
          className={classes.searchInput}
          placeholder="Search Display clients"
          onChange={filterUsers}
        />
      </div>
    </div>
  );
};

DisplayClientListToolbar.propTypes = {
  className: PropTypes.string,
};

export default DisplayClientListToolbar;
